import React from 'react';
import styled from 'styled-components';
import StatsBox from './StatsBox';
import { Flex } from './shared/Flex';
import { isMobile } from '@biosensesignal/web-sdk';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 12px 24px;
`;

const BoxesWrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: center;
`;


interface VitalSign<T> {
  value: T;
  isEnabled: boolean;
}

interface IStats {
  /**
   *  Object - contains health stats info
   */
  vitalSigns: {
    pulseRate: VitalSign<number>;
    respirationRate: VitalSign<number>;
    stress: VitalSign<number>;
    hrvSdnn: VitalSign<number>;
    spo2: VitalSign<number>;
    bloodPressure: VitalSign<BloodPressureValue>;
  };
}

export type BloodPressureValue = {
  systolic: number;
  diastolic: number;
};

const Stats = ({ vitalSigns }: IStats) => {
  const bloodPressureToDisplay =
    vitalSigns.bloodPressure.value?.systolic &&
      vitalSigns.bloodPressure.value?.diastolic
      ? vitalSigns.bloodPressure.value.systolic +
      '/' +
      vitalSigns.bloodPressure.value.diastolic
      : '--';

  return (
    <Wrapper>
      <BoxesWrapper>
        <StatsBox
          title={'PR'}
          value={
            vitalSigns.pulseRate.isEnabled
              ? vitalSigns.pulseRate.value || '--'
              : 'N/A'
          }
        />
        <StatsBox
          title={'RR'}
          value={
            vitalSigns.respirationRate.isEnabled
              ? vitalSigns.respirationRate.value || '--'
              : 'N/A'
          }
        />
        <StatsBox
          title={'SL'}
          value={
            vitalSigns.stress.isEnabled
              ? vitalSigns.stress.value || '--'
              : 'N/A'
          }
        />
        <StatsBox
          title={'SDNN'}
          value={
            vitalSigns.hrvSdnn.isEnabled
              ? vitalSigns.hrvSdnn.value || '--'
              : 'N/A'
          }
        />
        <StatsBox
          title={'BP'}
          value={
            vitalSigns.bloodPressure.isEnabled
              ? bloodPressureToDisplay
              : 'N/A'
          }
        />
        <StatsBox
          title={'SpO2'}
          value={
            vitalSigns.spo2.isEnabled
              ? (vitalSigns.spo2.value ? vitalSigns.spo2.value + '%' : '--')
              : 'N/A'
          }
        />

      </BoxesWrapper>
    </Wrapper>
  );
};

export default Stats;
